
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import SubmitButton from '@/components/controls/submit-button.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';
import { AdsActions } from '@/store/modules/ads/types';
import { AdStatus } from '@/store/modules/ads/ad';

export default Vue.extend({
  name: 'AdsFilter',
  components: {
    SubmitButton,
    Dropdown,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => [] as number[],
    },
  },
  computed: {
    ...mapGetters('user/profile', ['isSuperAdmin', 'isAdmin']),
    dropdownItems() {
      const items: DropdownItems = {};
      
      items.reset = {
        label: this.$t('Reset Filters'),
        icon: 'close',
      };
      
      if ((this.isSuperAdmin || this.isAdmin) && this.selectedItems && this.selectedItems.length) {
        items.restore = {
          hasTopBorder: true,
          label: this.$t('Restore'),
          count: this.selectedItems.length,
          disabled: !this.selectedItems.length,
        };

        items.remove = {
          label: this.$t('Delete'),
          count: this.selectedItems.length,
          disabled: !this.selectedItems.length,
        };
      }
      
      return items;
    },
  },
  data() {
    return {
      availableStatuses: {
        [AdStatus.Inactive]: this.$t('Inactive'),
        [AdStatus.Active]: this.$t('Active'),
        scheduled: this.$t('Scheduled'),
        completed: this.$t('Completed'),
      },
      search: '',
      status: '',
    };
  },
  methods: {
    ...mapActions('ads', {
      bulkDeleteAds: AdsActions.BULK_DELETE,
      bulkRestoreAds: AdsActions.BULK_RESTORE,
    }),
    initFilters(): void {
      this.search = this.$router.currentRoute.query.search || '';
      if (this.$router.currentRoute.query.completed === 'true' || this.$router.currentRoute.query.completed === '1') {
        this.status = 'completed';
      } else if (
        this.$router.currentRoute.query.scheduled === 'true' ||
        this.$router.currentRoute.query.scheduled === '1'
      ) {
        this.status = 'scheduled';
      } else {
        this.status = this.$router.currentRoute.query.status || '';
      }
    },
    applyFilters(): void {
      const { sort, direction, ...queryParams } = this.$route.query;
      const isCompleted = this.status === 'completed';
      const isScheduled = this.status === 'scheduled';

      this.$router.push({
        params: {
          page: 1,
        },
        query: {
          ...queryParams,
          search: this.search,
          status: isCompleted || isScheduled ? '' : this.status,
          completed: isCompleted ? 'true' : '',
          scheduled: isScheduled ? 'true' : '',
        },
      });
    },
    handleDropdownClick(action: string): void {
      if ('reset' === action) {
        this.$router.push({
          params: {
            page: 1,
          },
          query: {},
        });
      }

      if ('remove' === action) {
        const answer = window.confirm(this.$t('Do you really want to delete selected ads?'));
        if (answer) {
          this.bulkDeleteAds({ ids: this.selectedItems });
        }
      }

      if ('restore' === action) {
        const answer = window.confirm(this.$t('Do you really want to restore selected ads?'));
        if (answer) {
          this.bulkRestoreAds({ ids: this.selectedItems });
        }
      }
    },
  },
  created(): void {
    this.initFilters();
  },
  watch: {
    $route(): void {
      this.initFilters();
    },
  },
});
